import { render, staticRenderFns } from "./IchingGate.vue?vue&type=template&id=653d3b21&"
import script from "./IchingGate.vue?vue&type=script&lang=js&"
export * from "./IchingGate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports